import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/generic-module.svg'


const _withScopeId = n => (_pushScopeId("data-v-06321a5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "module-header",
  class: "row"
}
const _hoisted_2 = {
  id: "module-icon",
  class: "col-3"
}
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "module logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "module-title",
  class: "col-9"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_8 = {
  id: "exercises-container",
  class: "col-9"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "main-container",
    class: _normalizeClass({
      'apply-opacity': !_ctx.module.started
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.module.image)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.module.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.generateImageUrl(_ctx.module),
              alt: "module logo"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercises, (e) => {
          return (_openBlock(), _createElementBlock("p", {
            class: _normalizeClass(["exercise-entry", {
            'pointer-enabled': _ctx.attempts > 0 && e.answered,
            'apply-opacity': _ctx.attempts == 0 || !e.answered
          }]),
            key: e.elementId,
            onClick: ($event: any) => (_ctx.attempts > 0 && e.answered ? _ctx.openModulePage(e.module, e.page) : null)
          }, _toDisplayString(e.pageTitle) + " - " + _toDisplayString(e.description), 11, _hoisted_9))
        }), 128))
      ])
    ])
  ], 2))
}